<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between">
        <b-card-title>Atendimentos</b-card-title>
        <b-button size="xs" variant="default" @click="getAtendimentos(); show = !show" class="m-1">
          Ver Atendimentos
        </b-button>
      </div>
      <div v-if="show">
        <loading-animation :active.sync="loadingAtendimentos" :is-full-page="false" :opacity="1" color="#5895ff" />
        <b-table :fields="[
          {
            key: 'protocolo',
            label: $t('Detalhes'),
          },
          {
            key: 'cadastrado',
            label: $t('Data'),
          },
          {
            key: 'status_nome',
            label: $t('Status'),
          },
          {
            key: 'actions',
            label: '',
            class: 'text-right',
            thStyle: { width: '95px', minWidth: '95px' },
          },
        ]" :items="AtendimentosList" :responsive="true" striped hover show-empty small outlined stacked="md"
          table-class="mb-3">
          <template v-slot:cell(protocolo)="data">
            <span class="small">
              <ul>
                <li v-for="pessoa in data.item.pessoas_objetos" :key="pessoa.id">
                  <b>{{ pessoa.nome_completo }}</b>
                  <b-link :to="'/dashboard/usuario/edit/' + pessoa.id" target="_blank">
                    <i class="fas fa-external-link-alt"></i>
                  </b-link>
                </li>
              </ul>
              Tipo: <b>{{ data.item.tipo }}</b>
            </span>
            <br />
            <i class="mdi mdi-lock mdi-18px text-danger" v-if="data.item.privado == 1"
              v-b-popover.hover.top="'Atendimento com sigilo'"></i>
            <i class="mdi mdi-calendar-clock mdi-18px text-primary" v-b-popover.hover.top="
              'Data do Agendamento: ' + filterData(data.item.hora_prevista)
            " v-if="data.item.data_prevista != ''"></i>
            <b-link href="" :id="'pophover-' + data.item.id">
              <i class="mdi mdi-account-switch mdi-18px text-primary" v-if="data.item.outros_tecnicos[0] != ''"></i>
            </b-link>

            <b-popover :target="'pophover-' + data.item.id" triggers="hover" placement="right">
              <template #title>Técnicos Participantes</template>
              <ol>
                <li v-for="tecnico in data.item.outros_tecnicos" :key="tecnico">
                  <small>{{ tecnico }}</small>
                </li>
              </ol>
            </b-popover>
          </template>
          <template v-slot:cell(cadastrado)="data">
            {{ data.item.cadastrado }}
          </template>
          <template v-slot:cell(status_nome)="data">
            <span class="small" v-html="data.item.status_nome"></span>
          </template>
          <template v-slot:cell()="data">
            <button @click="redirectAtendimento(data.item.id, data.item.familia)"
              class="px-2 mb-0 btn btn-sm btn-success">
              <i class="mdi mdi-square-edit-outline" />
            </button>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img :alt="$t('No results')" class="mb-5" src="/img/icons/robot.svg" style="max-height: 165px" />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <b-pagination v-if="pagination.total > perPage" :per-page="perPage" :total-rows="pagination.total"
          @change="changePage" v-model="page" align="right" pills />
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingAtendimentos: false,
      show: false,
      AtendimentosList: [],
      search: "",
      page: 1,
      perPage: 5,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {
    // this.getAtendimentos();
  },
  methods: {
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAtendimentos();
      }
    },
    getAtendimentos() {
      this.loadingAtendimentos = true;
      axios
        .get("api/analytics/atendimentos/report", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.AtendimentosList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAtendimentos();
          } else {
            this.loadingAtendimentos = false;
          }
        })
        .catch(() => {
          this.loadingAtendimentos = false;
        });
    },
    redirectAtendimento(id, familia_id) {
      this.$router.push({
        path: `/dashboard/atendimentos/edit/${id}`,
        query: { familia_id: familia_id },
      });
    },
  },
};
</script>

<style></style>
